import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminAuditLog from './subscriptions/AdminAuditLog';

const AdminSubscriptionAuditLogPage = () => (
  <AdminLayout>
    <AdminAuditLog />
  </AdminLayout>
);

export default AdminSubscriptionAuditLogPage;
